<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap type-center">
      <h2 class="page-tit">회원 탈퇴</h2>
    </div>
    <h3 class="section-title">회원 탈퇴 확인</h3>

    <section class="agree__form">
      <article class="agree__container">
        <div class="agree__body terms__container">
          <p class="terms-tit">회원 탈퇴 안내</p>

          사이버 보안 취약점 정보 포털을 이용해주셔서 감사합니다. <br />
          회원탈퇴 요청 시, 사용하고 계신 아이디
          <p class="terms-content">{{ userId }}</p>
          는(은) 즉시 탈퇴 처리됩니다.
          <br />
          <p class="terms-content">
            사이버 보안 취약점 정보포털 이용정보(취약점신고 정보, 패치 접수
            정보등)가 삭제되며 복구가 불가하오니 신중하게 선택하시기 바랍니다.
          </p>
        </div>
        <div class="agree__footer">
          <p class="agree-label">회원 탈퇴 안내 사항을 확인 하였습니다.</p>
          <div class="chk__wrap">
            <label class="chk chk--circle"
              ><input
                type="radio"
                name="agree1"
                :value="true"
                v-model="agree"
              />확인함</label
            >
          </div>
        </div>
      </article>
    </section>

    <br />
    <table class="form-table type-block--mobile">
      <tbody>
        <tr>
          <th scope="row">비밀번호 확인</th>
          <td>
            <label for="password" class="sr-only">비밀번호 확인</label>
            <input
              type="password"
              id="password"
              class="form-table__input"
              v-model="verifyPassword"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btn__wrap type-bottom-board">
      <button
        type="button"
        class="btn btn--l btn--blue btn--m_full"
        v-on:click="removeUser"
      >
        탈퇴
      </button>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { inject, ref, onMounted } from "vue";
import { useStore } from "vuex";
import dc from "@/component/utils/DataChk.js";
import gt from "@/component/utils/GetTokenValue.js";
import rsa from "@/component/utils/RSAPublicKey.js";

export default {
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const agree = ref(null);
    const verifyPassword = ref(null);
    const userId = ref(gt.getUser());

    // methods 정의

    const removeUser = () => {
      if (!dc.nullChk(agree.value) || !agree.value) {
        alert("회원탈퇴 안내를 확인해 주십시오.");
        return;
      }
      if (!dc.nullChk(verifyPassword.value)) {
        alert("비밀번호를 입력하십시오.");
        return;
      }

      if (!confirm("정말로 회원탈퇴를 진행하시겠습니까?")) {
        return;
      }

      showLoading();
      axios
        .post("/core/pu/member/del", {
          password: rsa.encryptData(verifyPassword.value),
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("탈퇴처리가 완료되었습니다.\n메인 페이지로 이동합니다.");
            axios.get("/core/pu/member/logout").then(() => {
              router.push("/");
            });
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // life cycle 정의
    onMounted(() => {
      if (!dc.nullChk(gt.getUser())) {
        router.push("/");
      }
      rsa.getPublicKey();
    });

    // html에서 사용될 데이터 정의
    return {
      agree,
      verifyPassword,
      removeUser,
      userId,
    };
  },
};
</script>